import { ListItem, Stack, Typography } from '@mui/material';
import { Link, ReferenceField } from 'react-admin';

import { AccountAvatar } from '../accounts/AccountAvatar';
import { SaleName } from '../sales/SaleName';
import type { ActivityAccountCreated } from '../types';
import { RelativeDate } from '../misc/RelativeDate';
import { useActivityLogContext } from './ActivityLogContext';

type ActivityLogAccountCreatedProps = {
    activity: ActivityAccountCreated;
};

export function ActivityLogAccountCreated({
    activity,
}: ActivityLogAccountCreatedProps) {
    const context = useActivityLogContext();
    const { account } = activity;
    return (
        <ListItem disableGutters>
            <Stack direction="row" spacing={1} alignItems="center" width="100%">
                <AccountAvatar width={20} height={20} record={account} />
                <Typography
                    component="p"
                    variant="body2"
                    color="text.secondary"
                    flexGrow={1}
                >
                    <ReferenceField
                        source="sales_id"
                        reference="sales"
                        record={activity}
                        link={false}
                    >
                        <SaleName />
                    </ReferenceField>{' '}
                    added account{' '}
                    <Link to={`/accounts/${account.id}/show`}>
                        {account.name}
                    </Link>
                    {context === 'all' && (
                        <>
                            {' '}
                            <RelativeDate date={activity.date} />
                        </>
                    )}
                </Typography>
                {context === 'account' && (
                    <Typography
                        color="textSecondary"
                        variant="body2"
                        component="span"
                    >
                        <RelativeDate date={activity.date} />
                    </Typography>
                )}
            </Stack>
        </ListItem>
    );
}
